module.exports = __webpack_public_path__ + "img/1f54415.jpg";